/**
 * Resolve school display name for a session when API school_name is null
 * or is a bootstrap placeholder like "School #52".
 * schoolId on sessions is the Ritika external school id.
 */

export function isPlaceholderSchoolName(name) {
  return !name || /^School #\d+$/i.test(String(name).trim());
}

export function resolveSessionSchoolName(session, liveSchools = [], cohorts = []) {
  const fromSession = session?.schoolName;
  if (fromSession && !isPlaceholderSchoolName(fromSession)) {
    return fromSession;
  }

  const schoolId = session?.schoolId;
  if (schoolId != null && schoolId !== '') {
    const school = liveSchools.find(s => String(s.id) === String(schoolId));
    const fromDirectory = school?.school_name || school?.name;
    if (fromDirectory && !isPlaceholderSchoolName(fromDirectory)) {
      return fromDirectory;
    }
  }

  const cohort = cohorts.find(c => String(c.id) === String(session?.cohortId));
  if (cohort?.schoolName && !isPlaceholderSchoolName(cohort.schoolName)) {
    return cohort.schoolName;
  }

  if (cohort?.schoolId != null && cohort.schoolId !== '') {
    const school = liveSchools.find(s => String(s.id) === String(cohort.schoolId));
    const fromCohortSchool = school?.school_name || school?.name;
    if (fromCohortSchool && !isPlaceholderSchoolName(fromCohortSchool)) {
      return fromCohortSchool;
    }
  }

  // Keep non-empty API value only as last resort (including placeholder if nothing better).
  return fromSession || '';
}

export function enrichSessionSchoolName(session, liveSchools = [], cohorts = []) {
  if (!session) return session;
  const schoolName = resolveSessionSchoolName(session, liveSchools, cohorts);
  if (!schoolName || schoolName === session.schoolName) return session;
  return { ...session, schoolName };
}
